export default function MatchGuessWarning() {

  return(
    <div>
      <div className="w-1/2 lg:w-1/4 mx-auto text-center text-sm px-4 py-1 mb-4 bg-white border-yellow-500 text-yellow-500 border rounded-lg font-semibold">
        <span className="animate-pulse">Palpite não salvo!</span>
      </div>
    </div>
  )
}
